/**
 * Help kontekstowy (H4): mapa trasa panelu → tytuł sekcji USER_GUIDE.
 *
 * Jedno źródło prawdy dla dwóch stron kontraktu:
 *  - Topbar renderuje przycisk „?" prowadzący do `/pomoc#<slug sekcji>`,
 *  - HelpPage po wejściu czyta `location.hash` i przewija do tej sekcji.
 *
 * Tytuły MUSZĄ być literalnie równe nagłówkom `##` w USER_GUIDE.md — slug
 * liczy się z tytułu tą samą funkcją, którą HelpPage nadaje sekcjom id,
 * więc literówka tutaj kończy się „?" prowadzącym na górę Pomocy (fallback),
 * nigdy błędem.
 */

/** Ta sama transformacja co w HelpPage — trzymać w synchronizacji. */
export function helpSlugify(s: string): string {
  return s.toLowerCase().replace(/&/g, '').replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-');
}

/**
 * Dopasowanie po najdłuższym prefiksie ścieżki — `/admin/forms` musi wygrać
 * z `/forms`, dlatego wpisy są sprawdzane od najdłuższego klucza.
 */
const ROUTE_HELP: Record<string, string> = {
  '/': 'Pulpit',
  '/board': 'Tablica',
  '/forms': 'Formularze',
  '/incidents': 'Zdarzenia',
  '/analytics': 'Statystyki',
  '/reports': 'Raporty',
  '/instructors': 'Instruktorzy',
  '/planner': 'Planer',
  '/task-templates': 'Definicje czynności',
  '/duty-log': 'Dziennik Służby',
  '/failures': 'Awarie',
  '/inspections': 'Przeglądy',
  '/worktime': 'Rozliczenie czasu pracy (RCP)',
  '/execution': 'Wykonanie instruktorów',
  '/road-cards': 'Karty drogowe',
  '/rozklad': 'Rozkład jazdy',
  '/feedback': 'Centrum Zgłoszeń',
  '/notifications': 'Powiadomienia',
  '/messages': 'Wiadomości',
  '/legal': 'Centrum prawne i zgody',
  '/profile': 'Pierwsze uruchomienie',
  '/change-password': 'Pierwsze uruchomienie',
  '/settings/roles': 'Role i uprawnienia',
  '/admin/users': 'Użytkownicy',
  '/admin/drivers': 'Kierowcy',
  '/admin/cepik': 'Kierowcy', // B-705: opis weryfikacji jest w sekcji Kierowcy
  '/admin/vehicles': 'Pojazdy',
  '/admin/tasks': 'Dyspozycja',
  '/mapa-pojazdow': 'Mapa pojazdów',
  '/admin/forms': 'Kreator formularzy (Administrator)',
  '/admin/dictionaries': 'Słowniki',
  '/admin/lines': 'Linie / Trasy',
  '/admin/devices': 'Urządzenia',
  '/admin/documents': 'Dokumenty',
  '/admin/system': 'Ustawienia systemowe',
  '/admin/audit': 'Dziennik audytu',
  '/admin/numbering': 'Numeracja',
  '/admin/legal': 'Centrum prawne i zgody',
  '/admin/gdpr': 'Dane osobowe (RODO)',
  '/admin/external-dispatch': 'Synchronizacja DPK (integracja z systemem dyspozytorskim)',
};

/** Tytuł sekcji Pomocy dla bieżącej ścieżki (null = brak dopasowania → sama Pomoc). */
export function helpTopicForPath(pathname: string): string | null {
  if (pathname === '/') return ROUTE_HELP['/'];
  const keys = Object.keys(ROUTE_HELP).filter((k) => k !== '/').sort((a, b) => b.length - a.length);
  for (const k of keys) {
    if (pathname === k || pathname.startsWith(k + '/')) return ROUTE_HELP[k];
  }
  return null;
}

/** Docelowy adres Pomocy dla bieżącej ścieżki. */
export function helpHrefForPath(pathname: string): string {
  const topic = helpTopicForPath(pathname);
  return topic ? `/pomoc#${helpSlugify(topic)}` : '/pomoc';
}
